// import React, { Component } from 'react';
//
//
//
// export default class Footer extends Component {
//   render(){
//     return (
//       <div>
//         <div className="card rounded-0" style={{width:"100%", flexGrow:1, backgroundColor: "#002171"}}>
//           <div className="card-body text-white" style={{textAlign:"center"}}>
//               &copy; National Remote Sensing Centre
//           </div>
//         </div>
//       </div>
//     );
//   }
// }
import React from "react";
import colors from "./colors";
import moment from "moment";
// import {  Container } from 'mdbreact';

class FooterPage extends React.Component {
  render() {
    return (
      <footer
        className="page-footer font-small "
        style={{ backgroundColor: colors.final_footer, height: "auto" }}
      >
        <div style={{ float: "left" }}>
          <h5
            className="  mt-2 mb-3"
            style={{ marginLeft: "10px", fontWeight: "100" }}
          >
            {/* &copy; {new Date().getFullYear()} */}
            <a
              target="_blank"
              href="https://www.nrsc.gov.in/"
              rel="noopener noreferrer"
              style={{ textDecoration: "none" }}
            >
              {" "}
              <span className="full-text">National Remote Sensing Centre</span>
              <span className="short-text">NRSC</span>
            </a>
          </h5>
        </div>

        <div className="middle_bottom">
          <h5
            className="  mt-2 mb-3"
            style={{ margin: "0px", fontWeight: "100" }}
            // className="update_date"
          >
           {/* Last updated on{" "}*/}
             {/* {moment("25-06-2021", "DD-MM-YYYY").format("DD MMMM YYYY")}{" "} */}
			{/*moment("24-10-2024", "DD-MM-YYYY").format("DD MMMM YYYY")}{" "*/}
          </h5>
        </div>

        <div style={{ float: "right", marginRight: "10px" }}>
          <h5
            className="  mt-2 mb-3"
            style={{ margin: "0px", fontWeight: "100" }}
          >
            <a
              href="mailto:nhp_nrsc@nrsc.gov.in"
              rel="noopener noreferrer"
              style={{ textDecoration: "underline" }}
            >
             <span className="full-text"  style={{ textDecoration: "underline" }}>
              Contact Us</span>
              <span className="short-text"  style={{ textDecoration: "underline",fontSize:"10px" }}>Contact Us</span>
            </a>
          </h5>
        </div>
      </footer>
    );
  }
}

export default FooterPage;
